import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=64376836&scoped=true"
import script from "./factory.vue?vue&type=script&lang=js"
export * from "./factory.vue?vue&type=script&lang=js"
import style0 from "./factory.vue?vue&type=style&index=0&id=64376836&prod&lang=css"
import style1 from "./factory.vue?vue&type=style&index=1&id=64376836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64376836",
  null
  
)

export default component.exports